module.exports = __webpack_public_path__ + "img/duplicateContent.717abdc4.svg";